let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ex6pL")).then(() => parcelRequire('JXA9h'));